module.exports = __webpack_public_path__ + "static/media/creatures-palm.4104e020.svg";